// Cor pastel determinística por número de factura fornecedor.
// Mesma factura → sempre a mesma cor em qualquer vista (Financeiro, Compras,
// Análise Compras, etc.), evitando confusão do utilizador.

export const PALETA_FACTURA = [
  { bg: '#fef3c7', border: '#f59e0b', text: '#92400e' }, // amarelo
  { bg: '#dbeafe', border: '#3b82f6', text: '#1e40af' }, // azul
  { bg: '#e9d5ff', border: '#a855f7', text: '#6b21a8' }, // roxo
  { bg: '#dcfce7', border: '#22c55e', text: '#166534' }, // verde
  { bg: '#fce7f3', border: '#ec4899', text: '#9f1239' }, // rosa
  { bg: '#fed7aa', border: '#f97316', text: '#9a3412' }, // laranja
  { bg: '#cffafe', border: '#06b6d4', text: '#155e75' }, // ciano
  { bg: '#e0e7ff', border: '#6366f1', text: '#3730a3' }, // indigo
  { bg: '#fef9c3', border: '#eab308', text: '#854d0e' }, // amarelo alt
  { bg: '#f5f5f4', border: '#78716c', text: '#44403c' }, // neutro
]

// Hash simples DJB2 → índice na paleta
function hash(str) {
  let h = 5381
  const s = String(str || '')
  for (let i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0
  return Math.abs(h)
}

export function corPorFactura(numero) {
  if (!numero) return { bg: 'transparent', border: '#e5e7eb', text: '#6b7280' }
  const idx = hash(numero) % PALETA_FACTURA.length
  return PALETA_FACTURA[idx]
}

// Estilos pré-cozinhados para o chip pequeno/médio/grande
export function estiloChipFactura(numero, tamanho = 'medio') {
  const cor = corPorFactura(numero)
  const config = {
    pequeno: { fontSize: '11px', padding: '3px 9px', borderRadius: '12px' },
    medio: { fontSize: '13px', padding: '4px 11px', borderRadius: '14px' },
    grande: { fontSize: '15px', padding: '6px 14px', borderRadius: '16px' },
  }[tamanho] || {}
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    fontWeight: '700',
    background: cor.bg,
    color: cor.text,
    border: `1px solid ${cor.border}66`,
    whiteSpace: 'nowrap',
    ...config,
  }
}
